import { ATexts } from './ATexts';
import type { PageKey } from './page.types';

interface PageText {
    label: string;
    buttonLabel?: string;
    description: string;
}

/** The name, button text and description of every page, by its key (`PageService`). */
class PageTextsClass extends ATexts {
    public readonly TitleSuffix = 'DWC Tools';

    public readonly pages: Record<PageKey, PageText> = {
        entities: {
            label: 'Kontakte',
            buttonLabel: 'Zu den Kontakten',
            description: 'Alle Kontakte wie Personen, Firmen oder Vereine.',
        },
        persons: {
            label: 'Personen',
            buttonLabel: 'Personen verwalten',
            description: 'Alle Personen im Überblick.',
        },
        person: {
            label: 'Person',
            buttonLabel: 'Details ansehen',
            description: 'Details der Person.',
        },
        organizations: {
            label: 'Firmen',
            buttonLabel: 'Firmen verwalten',
            description: 'Alle Firmen, Vereine und Organisationen im Überblick.',
        },
        organization: {
            label: 'Firma',
            buttonLabel: 'Details ansehen',
            description: 'Details der Firma.',
        },
        ai_announcements: {
            label: 'KI-Erfassungsbögen',
            buttonLabel: 'KI-Erfassungsbögen ansehen',
            description: 'Pro KI-System, das Du nutzt, legst Du hier einen eigenen Erfassungsbogen an. Wo Du unsicher bist, trage Deine Vermutung ein.',
        },
        ai_announcement: {
            label: 'KI-Erfassungsbogen',
            buttonLabel: 'Details ansehen',
            description: 'Details des KI-Erfassungsbogens.',
        },
        helpers: {
            label: 'Helferlein',
            buttonLabel: 'Zu den Helferlein',
            description: 'Kleinere Tools, die einem das Leben einfacher machen.',
        },
        plain_text: {
            label: 'Klartext-Bereinigung',
            buttonLabel: 'Zum Tool',
            description: 'Texte aus KI oder externen Quellen normalisieren.',
        },
        admin: {
            label: 'Admin',
            buttonLabel: 'Zur Verwaltung',
            description: 'Verwaltung für Administratoren.',
        },
        users: {
            label: 'Benutzer',
            buttonLabel: 'Benutzerverwaltung',
            description: 'Alle Benutzerkonten im Überblick.',
        },
        teams: {
            label: 'Teams',
            buttonLabel: 'Teams verwalten',
            description: 'Die Teams und ihre Rechte.',
        },
        tags: {
            label: 'Tags',
            buttonLabel: 'Tags verwalten',
            description: 'Die Tags, mit denen Personen und Firmen eingeordnet werden.',
        },
        rights: {
            label: 'Rechte',
            buttonLabel: 'Rechte verwalten',
            description: 'Wer welche Personen und Firmen lesen, anlegen, bearbeiten und löschen darf.',
        },
        tag: {
            label: 'Tag',
            buttonLabel: 'Details ansehen',
            description: 'Details des Tags.',
        },
        right: {
            label: 'Recht',
            buttonLabel: 'Details ansehen',
            description: 'Details des Rechts.',
        },
        intranets: {
            label: 'Intranets',
            buttonLabel: 'Intranets verwalten',
            description: 'Lege Intranets an und vergib ihre Tags. Wer ein Intranet sieht, regelst Du über die Rechte.',
        },
        admin_intranet: {
            label: 'Intranet',
            buttonLabel: 'Details ansehen',
            description: 'Details des Intranets.',
        },
        intranet: {
            label: 'Intranet',
            buttonLabel: 'Intranet öffnen',
            description: '',
        },
        admin_team: {
            label: 'Team',
            buttonLabel: 'Details ansehen',
            description: 'Details des Teams.',
        },
        admin_user: {
            label: 'Benutzer',
            buttonLabel: 'Details ansehen',
            description: 'Details des Benutzers.',
        },
        positions: {
            label: 'Positionen',
            buttonLabel: 'Positionen verwalten',
            description: 'Die Positionen der Ansprechpartner in den Firmen.',
        },
        position: {
            label: 'Position',
            buttonLabel: 'Details ansehen',
            description: 'Details der Position.',
        },
        dashboard: {
            label: 'Dashboard',
            buttonLabel: 'Zum Dashboard',
            description: 'Alles im Überblick.',
        },
        favorites: {
            label: 'Favoriten',
            buttonLabel: 'Favoriten ansehen',
            description: 'Die Einträge, die Du Dir gemerkt hast.',
        },
        logout: {
            label: 'Abmelden',
            buttonLabel: 'Abmelden',
            description: 'Beendet Deine Sitzung auf diesem Gerät.',
        },
        messages: {
            label: 'Benachrichtigungen',
            buttonLabel: 'Lesen',
            description: 'Nachrichten und Hinweise für Dich.',
        },
        root: {
            label: 'Root',
            buttonLabel: 'Zu Root',
            description: 'Werkzeuge für die Root-Nerds.',
        },
        database: {
            label: 'Datenbank',
            buttonLabel: 'Zur Datenbank',
            description: 'Tabellen, Einträge, Verschlüsselung und Kennzahlen der Datenbank.',
        },
        email_test: {
            label: 'Test-E-Mail',
            buttonLabel: 'Zur Test-E-Mail',
            description: 'SMTP-Einstellungen ansehen und Testnachrichten an Benutzer und Teams schicken.',
        },
        sessions: {
            label: 'Sessions',
            buttonLabel: 'Session-Verwaltung',
            description: 'Alle gespeicherten Sitzungen mit Benutzer.',
        },
        search: {
            label: 'Suche',
            buttonLabel: 'Suchen',
            description: 'Durchsucht die DWC-Tools.',
        },
        microsoft: {
            label: 'Microsoft-Anmeldung',
            description: 'Die Rückkehr von der Anmeldung bei Microsoft.',
        },
        user: {
            label: 'Mein Konto',
            buttonLabel: 'Konto öffnen',
            description: 'Deine Daten und Dein Passwort.',
        },
    };
}

export const PageTexts = new PageTextsClass();
